import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/system/authentication/services/active-backend", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
